import { t } from "i18next"
import React, { forwardRef } from "react"
import { Button, Icon } from "semantic-ui-react"

const CustomDateInput = forwardRef(({ value, onClick, icon, className }, ref) => (
    <Button className={`el-picker ${className}`} onClick={onClick} ref={ref}>
        {value || <span className="el-picker__placeholder">{t('calendar.detail.selectDate')}</span>}<Icon name={icon} />
    </Button>
))

CustomDateInput.displayName = 'CustomDateInput'

export default CustomDateInput